













import { Component, Vue, Provide,Prop } from "vue-property-decorator";


@Component({
    name: "deleteDialog"
})
export default class CombinationProperty extends Vue {
    @Prop({}) dialogVisible!:Boolean
    
    private cancelConfirm () {
        this.$emit('cancelConfirm')
    }
    private deleteConfirm () {
        this.$emit('deleteConfirm')
    }
    private beforeClose (){
        this.$emit('cancelConfirm')
    }


}
